import React from "react";
import {Box} from "@mui/material";
import {GlobalState} from "../../global/GlobalState";
import {DownloadButton} from "./DownloadButton";
import {CopyButton} from "./CopyButton";
import CodeMirror from "@uiw/react-codemirror";
import {vscodeDark} from "@uiw/codemirror-theme-vscode";
import {Extension} from "@codemirror/state";
import {ReactCodeMirrorProps} from "@uiw/react-codemirror/src";

function getCode(children: string | string[]): string {
	if (typeof children === "string")
		return children;
	else
		// maybe use string join instead... not sure why it can be a string array
		return children[0];
}

export interface CodeBlockProps {
	readonly name: string;
	readonly language?: string;
	readonly showHeader?: boolean;
	readonly syntax?: Extension;
	readonly children: string | string[];
	readonly codeMirrorProps?: ReactCodeMirrorProps;
	readonly removePadding?: boolean;
	readonly editable?: boolean;
	readonly onChange?: any;
}

export function CodeBlock(props: CodeBlockProps) {
	const syntax = props.syntax && [props.syntax];
	
	return <Box style={{height: "100%", maxHeight: "80vh", overflowY: "auto"}}>
		{props.showHeader !== false
			? <>
				<CopyButton getText={() => getCode(props.children)}/>
				<DownloadButton name={props.name} getText={() => getCode(props.children)}/>
				{props.name}
			</>
			: undefined
		}
		<CodeMirror
			// removes padding and inner margin in order to align it with other code components such as the diff viewer
			className={props.removePadding ? "no-padding" : undefined}
			{...props.codeMirrorProps}
			value={getCode(props.children)}
			// maxHeight={props.maxHeight}
			// placeholder={props.placeholder}
			extensions={syntax}
			theme={GlobalState.paletteMode === "dark" ? vscodeDark : undefined}
			style={{flexGrow: 1}}
			editable={props.editable ?? false}
			indentWithTab={false}
			onChange={props.onChange}
		/>
	</Box>;
}
